/* eslint-disable max-len */
/* eslint-disable dot-notation */
/* eslint-disable no-console */
/* eslint-disable no-mixed-spaces-and-tabs */
/* eslint-disable import/extensions */
import { API, Auth, Storage } from 'aws-amplify';
import { generatePresignedUrl } from './presence_actions';
import axios from 'axios';
import { processApiUserData } from '../../utils/companyDataUtils';

// eslint-disable-next-line no-unused-vars
function init(arg0: string, arg1: string, _init: any, any: any)
{
	throw new Error('Function not implemented.');
}

export function getCompaniesList(query:string): Promise<any>
{
	return API.get('userManagement', `/getCompanies${query}`, init);
}

export function getCompaniesListAuth(query:string): Promise<any>
{
	return API.get('userManagement', `/getCompaniesList?search=${query}`, init);
}

export function otpExpires(body:any)
{
	return API.post('userManagement', '/otp', { body });
}

export function passwordExpires(body:any)
{
	return API.put('ssoUserManagement', '/sendTempPassword', { body });
}

export async function logoutUser(logoutAll: boolean = false)
{
	try
	{
		// const session = await Auth.currentSession();
		// const accessToken = session?.getAccessToken()?.getJwtToken();

		const config: any = {
			body : {}
		};

		if (logoutAll)
		{
			config.body.logoutAll = true;

			return API.post('ssoUserManagement', '/logout', config);
		}
		// else
		// {
		// 	config.headers = {
		// 		'x-access-token' : accessToken
		// 	};
		// }
	}
	catch (error)
	{
		console.error('Error during logout API call:', error);
		throw error;
	}
}

export function createEmployee(body:any)
{
	return API.post('ssoUserManagement', '/user/inlynk', { body });
}

export async function updateEmail(body:any)
{
	const session = await Auth.currentSession();
	const accessToken = session.getAccessToken().getJwtToken();

	return API.put('ssoUserManagement', '/changeEmail', {
		body,
		headers : {
			'x-cognito-access-token' : accessToken
		}
	});
}

export async function getUserData()
{
	const response = await API.get('ssoUserManagement', '/user/inlynk', init);

	return processApiUserData(response);
}

export function validateEmployeeExists(body:{email:string})
{
	// finds if the email is already in the system
	return API.post('ssoUserManagement', '/invitation/find-email', { body });
}

export function sendInvitation(body:{email:string})
{
	// sends an invitation to the email
	return API.post('ssoUserManagement', '/invitation/send', { body });
}

export function activateDeactivate(query:any)
{
	return API.post('userManagement', `/activateDeactivate?${query}`, init);
}

export function updateUser(body:any, query)
{
	const newBody = {
		...body,
		updateType : 'update',
		platform   : 'inlynk'

	};

	return API.put('userManagement', `/user?type=${query}`, { body: newBody });
}
export function updateUserProfileImage(body:any, query)
{
	const newBody = {
		...body,
		updateType : 'update',
		platform   : 'inlynk'

	};

	return API.put('ssoUserManagement', `/user?type=${query}`, { body: newBody });
}
export function updateUserAttributes(body)
{
	return API.put('ssoUserManagement', '/user', { body });
}
// for updating user profile, while userData.role : superadmin, employee, indivisual
export function updateProfilePersonal(body:any)
{
	return API.put('ssoUserManagement', '/user', { body });
}

export function updateProfileForCompany(body:any)
{
	return API.put('ssoUserManagement', '/user', { body });
}

// export function getCategoriesData(query:any)
// {
// 	return API.get('contentManagement', `/getCategories${query}`, init);
// }

export function getCategoriesData(query:any)
{
	return API.get('contentManagement', `/categories${query}`, init);
}

export function getCategoryData(query:any)
{
	return API.get('contentManagement', `/categories${query}`, init);
}

// / this below api is getting contentCount by passing category Id
export function getCatergoriesCount(query:any)
{
	return API.get('contentManagement', `/categoryCount${query}`, init);
}
export function getCategoriesCount(query:any)
{
	return API.get('contentManagement', `/categories${query}`, init);
}
export function getCategoryByCompany(query:any)
{
	return API.get('contentManagement', `/categories${query}`, init);
}
export function getCategoryByCompanyCount(query:any)
{
	return API.get('contentManagement', `/categories${query}`, init);
}
export function CreateCategory(body:any)
{
	return API.post('contentManagement', '/createCategories', { body });
}
export function EditCategory(body:any)
{
	return API.put('contentManagement', '/updateCategory', { body });
}
export function DeleteCategory(id:string)
{
	return API.del('contentManagement', `/deleteCategory?categoryId=${id}`, init);
}
export function AddContent(body:any)
{
	return API.post('contentManagement', '/createContent', { body });
}

export function EditContent(body:any)
{
	return API.put('contentManagement', '/updateContent', { body });
}
export const uploadToInMeet = async (file, fileName, files, selectedPic) =>
{
	try
	{
		const fullPath = `public/profileImages/${fileName}.jpeg`;
		const thumbnailPath = `public/profileImages/thumbnail/${fileName}.jpeg`;

		const [ presignedUrlResponse, thumbnailRes ] = await Promise.all([
			generatePresignedUrl({ key: fullPath, contentType: file.type }),
			generatePresignedUrl({ key: thumbnailPath, contentType: files.type })
		  ]);

		  if (!presignedUrlResponse?.status || !thumbnailRes?.status)
		{
			throw new Error('Failed to generate presigned URL');
		}
		const [ uploadResponse, thumbnailResponse ] = await Promise.all([
			axios.put(presignedUrlResponse.data, file, { headers: { 'Content-Type': file.type } }),
			axios.put(thumbnailRes.data, files, { headers: { 'Content-Type': files.type } })
		  ]);

		  if (uploadResponse.status !== 200 || thumbnailResponse.status !== 200)
		{
			throw new Error('Failed to upload file(s)');
		  }

		const timestamp = new Date().valueOf();
		const body = {
			profileImage      : `${process.env.REACT_APP_INMEET_S3_BASE_URL}/${fullPath}?t=${timestamp}`,
			profileKey        : fullPath,
			thumbnailImage    : `${process.env.REACT_APP_INMEET_S3_BASE_URL}/${thumbnailPath}?t=${timestamp}`,
			thumbnailImageKey : thumbnailPath
		};

		return body;
	}
	catch (err)
	{
		console.log(err, '-***');
	}

	// Return the final object containing the image URLs and keys
};
export async function updateProfilePic(file, fileName, files, selectedPic, type, metadata?: Record<string, any>)
{
	await Storage.configure({ bucket: process.env.REACT_APP_S3_BUCKET, region: process.env.REACT_APP_S3_BUCKET_REGION });

	try
	{
		// if (selectedPic === 'profile')
		// {
		// 	const body = await uploadToInMeet(file, fileName, files, selectedPic);

		// 	return body;
		// }
		// else
		// {
		const customPrefix = { public: `${type}/` };

		// S3 user-defined metadata: keys/values must be ASCII strings.
		const s3Metadata = metadata
			? Object.entries(metadata).reduce<Record<string, string>>((acc, [ k, v ]) =>
			{
				if (v !== undefined && v !== null && v !== '') acc[k] = String(v);

				return acc;
			}, {})
			: undefined;

		const imageKey = `${fileName}_${selectedPic === 'customLogo' ? 'logo' : selectedPic}`;
		const result:any = await Storage.put(`${imageKey}.jpeg`, file, {
			cacheControl : 'no-cache',
			contentType  : file.type,
			customPrefix,
			...(s3Metadata && { metadata: s3Metadata })
		});
		let resizeResult:any;

		if (selectedPic === 'profile' || selectedPic === 'customLogo')
		{
			const thumbnailKey = `${imageKey}_thumbnail.jpeg`;

				 resizeResult = await Storage.put(thumbnailKey, files, {
				contentType : file.type,
				customPrefix,
				...(s3Metadata && { metadata: s3Metadata })
			});
		}

		const body:any = {};

		if (selectedPic === 'banner')
		{
			body['bannerImage'] = `${process.env.REACT_APP_S3_BASE_URL}/${type}/${result.key}?t=${new Date().valueOf()}`;
			body['bannerKey'] = `${type}/${result.key}`;
		}
		else if (selectedPic === 'profile')
		{
			body['profileImage'] = `${process.env.REACT_APP_S3_BASE_URL}/${type}/${result.key}?t=${new Date().valueOf()}`;
			body['profileKey'] = `${type}/${result.key}`;
			body['thumbnailImage'] = `${process.env.REACT_APP_S3_BASE_URL}/${type}/${resizeResult?.key}?t=${new Date().valueOf()}`;
			body['thumbnailImageKey'] = `${type}/${resizeResult.key}`;
		}
		else if (selectedPic === 'customLogo')
		{
			body['logoImage'] = `${process.env.REACT_APP_S3_BASE_URL}/${type}/${result.key}?t=${new Date().valueOf()}`;
			body['logoThumbnailImage'] = `${process.env.REACT_APP_S3_BASE_URL}/${type}/${resizeResult?.key}?t=${new Date().valueOf()}`;
		}

		return body;
		// }
		// eslint-disable-next-line prefer-template
	}
	catch (err)
	{
		console.log(err);

		return err;
	}
}

export function categoryHiererchy(query:string)
{
	return API.get('contentManagement', `/categoriesHeiarchy${query}`, init);
}

export function getCountriesList()
{
	return API.get('userManagement', '/countriesList', init);
}

export function getStateList(countryCode)
{
	return API.get('userManagement', `/stateList/${countryCode}`, init);
}

export function getCitiesList(countryCode, stateCode)
{
	return API.get('userManagement', `/cityList/${countryCode}/${stateCode}`, init);
}
export function getCompaniesData(query)
{
	return API.get('userManagement', `/user${query}`, init);
}

export function getPersonalData(query)
{
	return API.get('userManagement', `/user${query}`, init);
}
export function getDashboardData()
{
	return API.get('userManagement', '/dashBoardCount', init);
}
export function getPolicies(query:any)
{
	return API.get('userManagement', `/getPolicies${query}`, init);
}
export function updatePolicies(body:any)
{
	return API.put('userManagement', '/updatePolicies', { body });
}
export function deleteProduct(query:any)
{
	return API.del('connectionManagement', `/product${query}`, init);
}

export function userVisits(body:any)
{
	return API.post('userManagement', '/visit', { body });
}
export function edmUserPopup(query)
{
	return API.put('userManagement', `/user?type=${query}`, init);
}

export const DeleteEmployee = (queryStringParameters:any) =>
{
	return API.del('ssoUserManagement', '/user', { queryStringParameters });
};

export const DeleteCompany = (queryStringParameters:any) =>
{
	return API.del('ssoUserManagement', '/user', { queryStringParameters });
};
export function getNetworkProfile(queryStringParameters:any)
{
	return API.get('userManagement', '/user', { queryStringParameters });
}

export function businessActivity(body:any)
{
	return API.post('userManagement', '/business', { body });
}

export function getActivity(queryStringParameters:any)
{
	return API.get('userManagement', '/business/getActivityV2', { queryStringParameters });
}

export function getMostUserActivity(queryStringParameters:any)
{
	return API.get('userManagement', '/business/mostActiveV2', { queryStringParameters });
}
export function getMostNetworks(queryStringParameters:any)
{
	return API.get('userManagement', '/business/rmDetails', { queryStringParameters });
}
export function getHeaderActivity(queryStringParameters:any)
{
	return API.get('userManagement', '/business/header', { queryStringParameters });
}

export function getHeadersCount()
{
	return API.get('userManagement', '/business/headers-count', init);
}

export function getNewsFeedAnalytics(queryStringParameters: {
	timeType: string;
	startDate?: number;
	endDate?: number;
	timezone?: string;
	userId?: string;
	zone?: string;
})
{
	return API.get('userManagement', '/business/news-feed-analytics', { queryStringParameters });
}

export function getNetworksAnalytics(queryStringParameters: { startDate?: number; endDate?: number } = {})
{
	return API.get('userManagement', '/business/networks-analytics', { queryStringParameters });
}

export function getDepartmentAnalytics(queryStringParameters: { startDate?: number; endDate?: number } = {})
{
	return API.get('userManagement', '/business/department-analytics', { queryStringParameters });
}

export function getChatCallsAnalytics(queryStringParameters: {
	timeType: string;
	startDate?: number;
	endDate?: number;
	timezone?: string;
	userId?: string;
	zone?: string;
})
{
	return API.get('userManagement', '/business/chat-calls-analytics', { queryStringParameters });
}

export function getCertificationsAnalytics(queryStringParameters: {
	timeType: string;
	startDate?: number;
	endDate?: number;
	timezone?: string;
	userId?: string;
	zone?: string;
})
{
	return API.get('userManagement', '/business/certifications-analytics', { queryStringParameters });
}

export function getTaskAnalytics(queryStringParameters: {
	timeType: string;
	startDate?: number;
	endDate?: number;
	timezone?: string;
	userId?: string;
	zone?: string;
})
{
	return API.get('userManagement', '/business/task-analytics', { queryStringParameters });
}

export function getMediadriveAnalytics(queryStringParameters: { startDate?: number; endDate?: number; userId?: string; zone?: string } = {})
{
	return API.get('userManagement', '/business/mediadrive-analytics', { queryStringParameters });
}

export function getContractsAnalytics(queryStringParameters: { startDate?: number; endDate?: number } = {})
{
	return API.get('userManagement', '/business/contracts-analytics', { queryStringParameters });
}

export function getModuleTimeSpentAnalytics(queryStringParameters: {
	startDate?: number;
	endDate?: number;
	userId?: string;
	zone?: string;
} = {})
{
	return API.get('userManagement', '/business/module-time-spent-analytics', { queryStringParameters });
}

export function getTopUsersByModuleAnalytics(queryStringParameters: {
	startDate: number;
	endDate: number;
	module: string;
	timeType?: string;
	limit?: number;
	skip?: number;
})
{
	return API.get('userManagement', '/business/top-users-by-module-analytics', { queryStringParameters });
}

export function getNetworkCompaniesList(queryStringParameters: { startDate?: number; endDate?: number } = {})
{
	return API.get('userManagement', '/business/network-companies-list', { queryStringParameters });
}

export function getTopNetworkCompaniesUsage(queryStringParameters: { startDate: number; endDate: number })
{
	return API.get('userManagement', '/business/top-network-companies-usage', { queryStringParameters });
}

export function getTopEmployeesUsage(queryStringParameters: {
	startDate: number;
	endDate: number;
	timeType: string;
	timezone?: string;
})
{
	return API.get('userManagement', '/business/top-employees-usage', { queryStringParameters });
}

export function getTopEmployeesChatHistory(queryStringParameters: {
	startDate: number;
	endDate: number;
	timeType: string;
	timezone?: string;
})
{
	return API.get('userManagement', '/business/top-employees-chat-history', { queryStringParameters });
}

export function usageGraph(queryStringParameters)
{
	return API.get('userManagement', '/business/usageGraph', { queryStringParameters });
}
export function usageAverage(queryStringParameters)
{
	return API.get('userManagement', '/business/average', { queryStringParameters });
}
export function companyUsage(queryStringParameters)
{
	return API.get('userManagement', '/api/v1/activity-logs', { queryStringParameters });
}

export const inAffiliateReferrerLogs = (body) =>
{
	return API.post('inAffiliate', '/referrerlogs', { body });
};
export const inAffiliateReferrerClicks = (body) =>
{
	return API.post('inAffiliate', '/referrerclicks', { body });
};

export function getChatTracking(queryStringParameters:any)
{
	return API.get('userManagement', '/business/chat-tracking-v2-header', { queryStringParameters });
}

// Employee Dashboard API - uses activity-logs endpoint
export function getEmployeeChatTracking(queryStringParameters:any)
{
	return API.get('userManagement', '/api/v1/activity-logs', { queryStringParameters: { ...queryStringParameters, type: 'chat-tracking-v2-header' } });
}

export function getChatTrackingTopUsers(queryStringParameters:any)
{
	return API.get('userManagement', '/business/chat-tracking-v2-top-user', { queryStringParameters });
}

export function getEmployeeList(queryStringParameters:any)
{
	return API.get('userManagement', '/business/chat-tracking', { queryStringParameters });
}

export function getEmployeeCount(queryStringParameters:any)
{
	return API.get('userManagement', '/business/chat-tracking', { queryStringParameters });
}

export function getReportData(queryStringParameters:any)
{
	return API.get('userManagement', '/business/report', { queryStringParameters });
}

// Dashboard Admin API functions
export function getDashboardAdminUsers(queryStringParameters:any)
{
	return API.get('userManagement', '/api/v1/dashboard-admin', { queryStringParameters });
}

export function addDashboardAdminUsers(userIds: string[])
{
	return API.put('userManagement', '/api/v1/dashboard-admin?type=add', {
		body : { userIds }
	});
}

export function removeDashboardAdminUsers(userIds: string[])
{
	return API.put('userManagement', '/api/v1/dashboard-admin?type=delete', {
		body : { userIds }
	});
}

export function getUserSessions()
{
	return API.get('ssoUserManagement', '/user/sessions', {});
}